module.exports = __webpack_public_path__ + "img/tm2.e2546053.png";